<template>
  <div class="jinriShow chat_img">
    <div v-for="(item, ind) in content" :key="ind">
      <div class="mainTitle" v-if="item.standardEnName == 'appName' && getQuery('dataType') != 2 ">{{ item.standardData }}</div>
      <!-- <div class="subtitle" v-if="item.standardEnName == 'subhead'">{{ item.standardData }}</div>
      <div class="information" v-if="item.standardData && (item.standardEnName == 'writer' || item.standardEnName == 'releaseTime')">
        <div class="information1" v-if="item.standardEnName == 'writer'">
          <span>作者 : </span><span>{{ item.standardData }}</span>
        </div>
        <div class="information2" v-else>
          <span>发布日期 : </span><span>{{ item.standardData }}</span>
        </div>
      </div> -->
      <div class="information" v-if="item.standardEnName == 'releaseTime' && (publishUserName || publishTime)">
          <span v-if="publishUserName">发布人 : </span><span>{{ publishUserName }}</span><span v-if="publishTime" class="time">{{ publishTime }}</span>
      </div>

      <div class="detailInfor" v-if="item.standardData && item.standardEnName != 'appName' && item.standardEnName != 'subhead' && item.standardEnName != 'writer' && item.standardEnName != 'releaseTime' && item.standardData != 'theoneandonlyAddtoCart'">
        <div v-if="!platform && isPic(item.standardData) && mediaMarking && item.fileTypeDetail == 2 && item.standardEnName != 'mainFigure'" style="text-align: center; text-indent: 0">
          <img :src="item.standardData" alt="" />
        </div>

        <div v-else-if="!platform && isVideo(item.standardData) && mediaMarking && item.fileTypeDetail == 1" style="text-align: center; text-indent: 0">
          <Video :src="item.standardData" :placeholder="placeholderImage" width="100%" height="360px"></Video>
        </div>

        <iframe v-else-if="!platform && item.fileTypeDetail == 4" :src="getLink(item.standardData)" frameborder="0" width="96%" height="500px"></iframe>
        <iframe v-else-if="!platform && item.standardEnName == 'mediaMarking' && item.standardData" :src="getLink(item.standardData, 'id')" frameborder="0" width="96%" height="970px"></iframe>
        <!-- <span class="lineHeight" v-else-if="item.standardEnName != 'product_experience'" v-html="processLinks(item.standardData).replace(/\n/g, '</br>')"></span> -->
        <span class="lineHeight" v-else-if="item.fileTypeDetail != 2 && item.fileTypeDetail != 1 && item.standardEnName != 'product_experience' && mediaMarking && item.standardEnName != 'mainFigure'" v-html="item.standardData.replace(/\n/g, '</br>')"></span>
      </div>
    </div>
  </div>
</template>
<script>
import Video from '../videos.vue'
export default {
  name: 'jinriShowContent',
  components: {
    Video
  },
  props: {
    content: {
      type: Array
    },
    demonstrations: {
      type: String,
      default: 'cmwz'
    },
    placeholderImage:String
  },
  computed:{
    mediaMarking(){
      return !this.content.filter((tags) => tags.fileTypeDetail == 4).length && !this.content.filter((tags) => tags.standardEnName == 'mediaMarking' && tags.standardData).length
    },
    platform(){
      return this.getQuery('floorflowId') == 'platform-show'//简介层
    }
  },
  data() {
    return {
      titleShow: {},
      publishUserName: this.getQuery('publishUserName'),
      publishTime: this.getQuery('publishTime')
    }
  },
  mounted() {
    // if(this.demonstrations=='cmwz'){
      this.getTitle();
    // }
  },
  methods: {
    getLink(link, id) {
      if (id) {
        return `https://${window.location.host}/zciid-deliverable/api/CatalogScrolling/catalogScrollingData?appId=` + link + '&pfId=' + window.$pfId
      }
      if (link.indexOf('/space/transform') > -1) {
        return link
      }
      return `https://${window.location.host}/cme-sso-app/space/transform?id=` + link.split('/')[link.split('/').length - 1].split('.')[0]
    },
    getTitle() {
      this.$http
        .get('/zciid-deliverable/showPlatformStyle/flow/api/get/getContentByIdAndStandardId.json', {
          contentId: this.$contentId
        })
        .then((res) => {
          if (res.state == 1) {
            console.log(this.publishUserName);
            
            if(!this.publishUserName){
              this.publishUserName = res.data.userName
            }
            if(!this.publishTime){
              this.publishTime = res.data.submitTime
            }
            // this.$http
            //   .get('/aassid/cms/client/api/getUserAppList', {
            //     userId: res.data.userId
            //   })
            //   .then((res) => {
            //     if (res.state == 1) {
            //       if (res.data.headPhoto) {
            //         res.data.headPhoto = window.location.origin + '/cme-sso-app/showimg/' + JSON.parse(res.data.headPhoto)[0].id
            //       }
            //       this.titleShow = res.data
            //     }
            //   })
          }
        })
    },
    //处理文本中的链接
    processLinks(txtContent) {
      // var httpReg = new RegExp('(http[s]{0,1}|ftp)://[a-zA-Z0-9\\.\\-]+\\.([a-zA-Z]{2,4})(:\\d+)?(/[a-zA-Z0-9\\.\\-~!@#$%^&amp;*+?:_/=<>]*)?', 'gi') //用于判断文本内容超链接
      // //文本地址变为a链接
      // return txtContent.replace(httpReg, function (httpText) {
      //   return '<a style="color:#0c78cf;" href="' + httpText + '"target="_blank">' + httpText + '</a>'
      // })

      let result = txtContent
      let startIndex = 0
      while (true) {
        const start = result.indexOf('<div data-w-e-type="video"', startIndex)
        if (start === -1) {
          break
        }
        const end = result.indexOf('</video>\r\n</div>', start)
        if (end === -1) {
          break
        }
        const endLength = '</video>\r\n</div>'.length
        const videoDiv = result.slice(start, end + endLength)
        const srcMatch = videoDiv.match(/src="([^"]+)"/)
        const src = srcMatch ? srcMatch[1] : ''
        const replacement = `<Videos src="${src}" width="100%" height="360px"></Videos>`
        result = result.replace(videoDiv, replacement)
        startIndex = start + replacement.length
      }
      return result
    },
    isPic(url) {
      if ((url && typeof url == 'string' && url.indexOf('.png') > 0) || (url && typeof url == 'string' && url.indexOf('.jpg') > 0)) {
        return true
      }
      return false
    }
  }
}
</script>
<style>
.jinriShow .lineHeight p {
  line-height: 18px;
}
.jinriShow .lineHeight div[data-w-e-type='video'] {
  text-align: center;
}
.jinriShow .lineHeight img,
.jinriShow .lineHeight video {
  width: 100%;
  /* max-height: 360px; */
}
</style>
<style scoped>
.title {
  padding-left: 30px;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
  background: url('../../assets/image/images/abduction_zsb.png') no-repeat left center / 20px 20px;
}
.jinriShow {
  padding: 20px 10px 0;
  height: calc(100% - 20px);
  width: 100%;
  /* border: 1px solid #ededed; */
  box-sizing: border-box;
}
.detail-contents .jinriShow {
  padding-top: 4px;
}
.mainTitle {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  font-size: 18px;
  font-weight: 800;
  color: #333;
  margin-bottom: 14px;
  text-align: center;
}
.subtitle {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 14px;
}
.statement {
  background-color: #f7f7f7;
  padding: 13px 20px;
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}
.information {
  text-align: center;
  margin-bottom: 14px;
}
.information .time{
  margin-left: 14px;
}
.information span {
  font-size: 12px;
  color: #666;
}
.detailInfor {
  margin-bottom: 12px;
  line-height: 26px;
  font-size: 14px;
  /* text-indent: 24px; */
}
.detailInfor:last-child {
  margin-bottom: 0;
}
.detailInfor img,
.detailInfor video {
  width: 100%;
  /* max-height: 360px; */
}
</style>
>



// WEBPACK FOOTER //
// src/components/floorBlock/jinriShowContent.vue